export function LaserClassFactory() {
    return function LaserClass() {
        this.name = null;
        this.code = null;
        this.id = null;
    }
}
